module.exports = __webpack_public_path__ + "static/media/logo-half-bottom.1bc8f02d.svg";